var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { AUTH_STATUS, DEFAULT_MANUAL_FORMS_BUTTON_TEXT, } from "../../lib/constants";
import BaseCredentialsRoute from "../../features/auth/routes/credentials";
import { PHASE } from "../../routeConfig";
import { completedPage } from "../../lib/Avo";
import { enteredUnlinkedApplication } from "../../features/unlinked-application/unlinkedApplicationSlice";
import { setAutoAuth } from "../../features/auth/authSlice";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import { useHistory } from "react-router-dom";
import useUnlinkedApplicationEntryRoute from "../../features/unlinked-application/useUnlinkedApplicationEntryRoute";
export default function AutoCredentialsRoute() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var _a = useAppSelector(function (state) { return state.auth.auto; }), authStatus = _a.status, challengeType = _a.challengeType, challengeData = _a.challengeData, connectionId = _a.accountInfo.connectionId;
    var selectedIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.auto; });
    var push = useHistory().push;
    var enableFormExperience = useAppSelector(function (state) { return state.configuration; }).enableFormExperience;
    var dispatch = useAppDispatch();
    var unlinkedEntryRoute = useUnlinkedApplicationEntryRoute();
    function handleFullFormClick() {
        dispatch(enteredUnlinkedApplication("manual-forms"));
        var nextPhase = enableFormExperience
            ? unlinkedEntryRoute
            : PHASE.MID_FUNNEL_ADS_UNSUPPORTED_ISSUER;
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: DEFAULT_MANUAL_FORMS_BUTTON_TEXT, optionSelected: DEFAULT_MANUAL_FORMS_BUTTON_TEXT }));
        push(nextPhase);
    }
    // reset auth status every time we intially render the credential phase
    var onLoad = React.useCallback(function () {
        dispatch(setAutoAuth({ status: AUTH_STATUS.INITIAL }));
    }, [dispatch]);
    if (!(selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id)) {
        return null;
    }
    return (React.createElement(BaseCredentialsRoute, { handleFullFormClick: handleFullFormClick, onLoad: onLoad, onSubmit: function () {
            return dispatch(setAutoAuth({ status: AUTH_STATUS.AUTHENTICATING }));
        }, issuer: selectedIssuer, authStatus: authStatus, challengeType: challengeType, challengeData: challengeData, connectionId: connectionId }));
}
